module.exports = __webpack_public_path__ + "img/coupon-1.24f8cee6.png";